<template>
  <div class="project-price-page">
    <aside class="project-price-sidebar">
      <button
        v-for="item in menuItems"
        :key="item.key"
        type="button"
        class="project-price-menu-item"
        :class="{ active: activeMenu === item.key }"
        @click="activeMenu = item.key"
      >
        {{ item.title }}
      </button>
    </aside>

    <main class="project-price-content">
      <div class="project-price-header">
        <h3>{{ activeTitle }}</h3>
        <div
          v-if="isDataTab"
          class="project-price-actions"
        >
          <b-button
            variant="outline-secondary"
            @click="fetchRows"
          >
            Frissítés
          </b-button>
          <b-button
            variant="primary"
            :disabled="saving || loading"
            @click="saveRows"
          >
            {{ saving ? 'Mentés...' : 'Mentés' }}
          </b-button>
        </div>
      </div>

      <div
        v-if="!isDataTab && activeMenu === 'importalas'"
        class="project-price-placeholder"
      >
        Importálás felület következő lépésben kerül bekötésre.
      </div>
      <div
        v-else-if="!isDataTab && activeMenu === 'korrekcio'"
        class="project-price-placeholder"
      >
        Korrekció felület következő lépésben kerül bekötésre.
      </div>

      <div
        v-else-if="loading"
        class="project-price-placeholder"
      >
        Betöltés...
      </div>

      <div
        v-else-if="error"
        class="project-price-placeholder error"
      >
        {{ error }}
      </div>

      <div
        v-else
        class="project-price-list"
      >
        <div
          v-for="row in rows"
          :key="row.id"
          class="project-price-card"
        >
          <div class="project-price-item-text">
            {{ row.item_text }}
          </div>
          <div class="project-price-fields">
            <label class="project-price-field">
              <span>Egys.</span>
              <input
                v-model="row.unit"
                type="text"
                class="prep-input"
              >
            </label>
            <label class="project-price-field">
              <span>Anyag egységár</span>
              <input
                v-model.number="row.material_unit_price"
                type="number"
                class="prep-input"
              >
            </label>
            <label class="project-price-field">
              <span>Alap díj egységre</span>
              <input
                v-model.number="row.base_fee_unit"
                type="number"
                class="prep-input"
              >
            </label>
          </div>
        </div>

        <div
          v-if="!rows.length"
          class="project-price-placeholder"
        >
          Nincs megjeleníthető tétel.
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import { BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ProjectPriceIndex',
  components: { BButton },
  data() {
    return {
      activeMenu: 'jarulekos-ar',
      loading: false,
      saving: false,
      error: '',
      rows: [],
      menuItems: [
        { key: 'jarulekos-ar', title: 'Járulákos Ár' },
        { key: 'zsaluzas-allvanyozas-ar', title: 'Zaluzás álványozozás Ár' },
        { key: 'sikalapozas-ar', title: 'Sikalapozás Ár' },
        { key: 'viztelenites-ar', title: 'Víztelenítés Ár' },
        { key: 'melyalapozas-ar', title: 'Mélyalapozás Ár' },
        { key: 'helyszini-beton-vasbeton-ar', title: 'Helyszini Beton és vasbeton Ár' },
        { key: 'egyeb-ar', title: 'Egyéb Ár' },
        { key: 'importalas', title: 'Importálás' },
        { key: 'korrekcio', title: 'Korrekció' },
      ],
    }
  },
  computed: {
    activeTitle() {
      const item = this.menuItems.find(m => m.key === this.activeMenu)
      return item ? item.title : 'Projekt ár'
    },
    isDataTab() {
      return [
        'jarulekos-ar',
        'zsaluzas-allvanyozas-ar',
        'sikalapozas-ar',
        'viztelenites-ar',
        'melyalapozas-ar',
        'helyszini-beton-vasbeton-ar',
        'egyeb-ar',
      ].includes(this.activeMenu)
    },
  },
  watch: {
    activeMenu() {
      if (!this.isDataTab) {
        this.rows = []
        this.error = ''
        return
      }
      this.fetchRows()
    },
  },
  mounted() {
    this.fetchRows()
  },
  methods: {
    fetchRows() {
      if (!this.isDataTab) return
      this.loading = true
      this.error = ''
      axios({
        method: 'get',
        url: `project-price/catalog/${this.activeMenu}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        const payload = Array.isArray(response.data) ? response.data : []
        this.rows = payload.map(item => ({
          id: item.id,
          item_text: item.item_text || '',
          unit: item.unit || '',
          material_unit_price: item.material_unit_price ?? null,
          base_fee_unit: item.base_fee_unit ?? null,
        }))
      }).catch(() => {
        this.error = 'Nem sikerült betölteni a projekt ár adatokat.'
      }).finally(() => {
        this.loading = false
      })
    },
    saveRows() {
      if (!this.isDataTab) return
      this.saving = true
      axios({
        method: 'post',
        url: `project-price/catalog/${this.activeMenu}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          entries: this.rows.map(row => ({
            item_id: row.id,
            unit: row.unit || null,
            material_unit_price: row.material_unit_price,
            base_fee_unit: row.base_fee_unit,
          })),
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Projekt ár mentve',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Mentés közben hiba történt',
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      }).finally(() => {
        this.saving = false
      })
    },
  },
}
</script>

<style scoped>
.project-price-page {
  min-height: calc(100vh - 130px);
  display: grid;
  grid-template-columns: 270px 1fr;
  gap: 1rem;
}

.project-price-sidebar {
  background: #111d44;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.project-price-menu-item {
  text-align: left;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 8px;
  background: rgba(30, 42, 80, 0.7);
  color: #d6deff;
  padding: 0.65rem 0.8rem;
  font-weight: 600;
}

.project-price-menu-item.active {
  background: #2f66c8;
  border-color: #2f66c8;
  color: #fff;
}

.project-price-content {
  background: #111d44;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  padding: 1rem;
}

.project-price-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.project-price-actions {
  display: flex;
  gap: 0.5rem;
}

.project-price-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.project-price-card {
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  padding: 0.9rem;
  background: rgba(22, 32, 66, 0.7);
}

.project-price-item-text {
  color: #f2f4ff;
  font-weight: 700;
  margin-bottom: 0.65rem;
}

.project-price-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 0.6rem;
}

.project-price-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.project-price-field span {
  color: #c7d2fe;
  font-size: 0.78rem;
  font-weight: 700;
}

.prep-input {
  width: 100%;
  background: rgba(16, 24, 54, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 6px;
  color: #e5e7eb;
  padding: 0.35rem 0.5rem;
}

.project-price-placeholder {
  color: #d1d5db;
  padding: 1rem;
  border: 1px dashed rgba(148, 163, 184, 0.35);
  border-radius: 8px;
}

.project-price-placeholder.error {
  color: #fca5a5;
}

@media (max-width: 991px) {
  .project-price-page {
    grid-template-columns: 1fr;
  }

  .project-price-fields {
    grid-template-columns: 1fr;
  }
}
</style>
